import React from 'react'
import PropTypes from 'prop-types'
import CSS from './index.module.css'
import BaseComponent from '@base/BaseComponent'

class GLOrderIntegralView extends BaseComponent {
	static propTypes = {
		iconUrl: PropTypes.string,
		content: PropTypes.string,
		point: PropTypes.oneOfType(PropTypes.string, PropTypes.number),
		marginHorizontal: PropTypes.string, // 水平
		marginVertical: PropTypes.string, // 垂直
	}

	static defaultProps = {
		iconUrl: '',
		content: '',
		point: '',
		marginHorizontal: '.24rem',
		marginVertical: '.2rem',
	}

	render() {
		let { iconUrl, content, point, marginHorizontal, marginVertical } = this.props

		// iconUrl = 'https://webapp.iskytrip.com/static/media/download-bg.339dc1b2.png'
		// content = '提示信息，替换福{}积分，您将获得'
		// point = 39

		let array = content.split('{}') || []

		if (+point === 0) {
			return null
		}

		return (
			<div>
				<div
					className={CSS.section}
					style={{
						marginLeft: marginHorizontal,
						marginRight: marginHorizontal,
						marginTop: marginVertical,
						marginBottom: marginVertical,
					}}
				>
					<img className={CSS.sectionIcon} src={iconUrl} alt='' />
					<div className={CSS.sectionText}>
						{array.map((item, index) => {
							return (
								<React.Fragment key={index}>
									{item || ''}
									{index === 0 ? <span>{point}</span> : null}
								</React.Fragment>
							)
						})}
					</div>
				</div>
			</div>
		)
	}
}

export default GLOrderIntegralView
